import { useTranslation } from 'react-i18next'

export default function UpdateDividersSections({ dividerOffsets, removeDivider }) {
  const [t] = useTranslation()

  return dividerOffsets?.map((offset, index) => ({
    id: offset,
    offset,
    title: t('ImageBrowserViewer.itemNumber', 'Item {itemNumber}', { itemNumber: index + 1 }),
    action:
      index > 0 && removeDivider
        ? {
            text: t('ImageBrowserViewer.removeDivider', 'Remove Divider'),
            onClick: () => removeDivider(offset),
          }
        : undefined,
  }))
}
